const API_BASE_URL = process.env.REACT_APP_URL_backend;

export const api = {
    get: async (endpoint) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                throw new Error('No authentication token found');
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                const error = await response.json();
                console.error('API Error:', error);
                throw new Error(error.message || 'Network response was not ok');
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('API Call Failed:', error);
            throw error;
        }
    },

    post: async (endpoint, data) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                throw new Error('No authentication token found');
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                const error = await response.json();
                console.error('API Error:', error);
                throw new Error(error.message || 'Network response was not ok');
            }
            
            return response.json();
        } catch (error) {
            console.error('API Call Failed:', error);
            throw error;
        }
    },

    put: async (endpoint, data) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                throw new Error('No authentication token found');
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            
            if (!response.ok) {
                const error = await response.json();
                console.error('API Error:', error);
                throw new Error(error.message || 'Network response was not ok');
            }
            
            return response.json();
        } catch (error) {
            console.error('API Call Failed:', error);
            throw error;
        }
    },

    delete: async (endpoint) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                throw new Error('No authentication token found');
            }

            const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                const error = await response.json();
                console.error('API Error:', error);
                throw new Error(error.message || 'Network response was not ok');
            }
            
            return response.json();
        } catch (error) {
            console.error('API Call Failed:', error);
            throw error;
        }
    }
}; 
